import React from 'react';
import MissionsList from '../components/MissionList/MissionList';

export default function Missions() {
  return (
    <MissionsList />
  );
}
